/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export interface ArrayConfiguration {
  allowAdd?: boolean;
  allowDelete?: boolean;
  deleteMessage?: string | null;
}

export class ArrayConfiguration {
  allowAdd?: boolean;
  allowDelete?: boolean;
  deleteMessage?: string | null;

  constructor(value: ArrayConfiguration) {
    this.allowAdd = value?.allowAdd;
    this.allowDelete = value?.allowDelete;
    this.deleteMessage = value?.deleteMessage;
  }
}
